"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Email_1 = tslib_1.__importDefault(require("@mui/icons-material/Email"));
const Smartphone_1 = tslib_1.__importDefault(require("@mui/icons-material/Smartphone"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const CoreContext_1 = require("../_InternalComponents/CoreContext");
const isDomainDifferent_1 = require("../_InternalUtils/isDomainDifferent");
const InfoCardSkeleton_1 = tslib_1.__importDefault(require("./InfoCardSkeleton"));
const InfoCardUser_1 = require("./InfoCardUser");
const ICON_OPACITY = "0.54";
const getStyles = ({ theme }) => ({
    userInfoText: {
        marginBottom: theme.spacing(0.5),
    },
    gridContainer: {
        alignItems: "center",
        gridGap: theme.spacing(1),
    },
    gridItem: {
        display: "flex",
        alignItems: "center",
        gridGap: theme.spacing(1),
    },
    icon: {
        marginBottom: theme.spacing(0.5),
        fontSize: "inherit",
    },
});
const InfoCardContent = (props) => {
    const { loading, user, showExtended } = props;
    const theme = (0, styles_1.useTheme)();
    const styles = getStyles({ theme });
    const userName = (0, InfoCardUser_1.isBasicUser)(user) ? user?.shortName : user?.userName;
    const phoneNumber = (0, InfoCardUser_1.isBasicUser)(user) && user.phoneNumber ? `+${user.phoneNumber.countryCode} ${user.phoneNumber.nationalNumber}` : "-";
    const email = (0, InfoCardUser_1.isBasicUser)(user) && user.email ? user.email : "-";
    const contextDomain = react_1.default.useContext(CoreContext_1.CoreContext)?.domain;
    // Return a loading skeleton if loading === true
    if (loading)
        return react_1.default.createElement(InfoCardSkeleton_1.default, { animation: "wave" });
    // Return user information if user exists. Also check if extended info should be shown.
    if (user)
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Typography_1.default, { variant: "subtitle2", sx: styles.userInfoText }, user.name),
            react_1.default.createElement(Typography_1.default, { color: "textSecondary", sx: styles.userInfoText },
                (0, isDomainDifferent_1.isDomainDifferent)(contextDomain, user?.domain) && user?.domain?.name,
                userName),
            react_1.default.createElement(Typography_1.default, { color: "textSecondary", sx: styles.userInfoText }, user.customer?.name),
            showExtended && (0, InfoCardUser_1.isBasicUser)(user) && (react_1.default.createElement(Grid_1.default, { key: "userEmailAndPhone", sx: styles.gridContainer },
                react_1.default.createElement(Grid_1.default, { sx: styles.gridItem },
                    react_1.default.createElement(Email_1.default, { sx: styles.icon, opacity: ICON_OPACITY }),
                    react_1.default.createElement(Typography_1.default, { color: "textSecondary", sx: styles.userInfoText }, email)),
                react_1.default.createElement(Grid_1.default, { sx: styles.gridItem },
                    react_1.default.createElement(Smartphone_1.default, { sx: styles.icon, opacity: ICON_OPACITY }),
                    react_1.default.createElement(Typography_1.default, { color: "textSecondary" }, phoneNumber))))));
    // Return an empty skeleton if loading && user === false
    return react_1.default.createElement(InfoCardSkeleton_1.default, { animation: false });
};
exports.default = InfoCardContent;
